import { Typography as AntTypography } from 'antd'
import type { ButtonHTMLAttributes, ComponentProps, KeyboardEvent, MouseEvent } from 'react'

/** @deprecated Use `Size` instead */
type DeprecatedSize = 'base' | 'sm' | 'lg' | 'xl'

type Size = 'small' | 'medium' | 'large' | 'extra-large' | DeprecatedSize

const sizeClass: Record<Size, string> = {
  base: '',
  sm: 'ant-typography-text-sm',
  lg: 'ant-typography-text-lg',
  xl: 'ant-typography-text-xl',
  small: 'ant-typography-text-sm',
  medium: '',
  large: 'ant-typography-text-lg',
  'extra-large': 'ant-typography-text-xl',
}

export type TextProps = {
  size?: Size
} & ComponentProps<typeof AntTypography.Text>

const Text = ({ size = 'base', ...props }: TextProps) => {
  return <AntTypography.Text {...props} className={`${sizeClass[size]} ${props.className ?? ''}`} />
}

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>

const Button = (props: ButtonProps) => {
  const handleKeyDown = (event: KeyboardEvent) => {
    props.onKeyDown?.(event as unknown as KeyboardEvent<HTMLButtonElement>)
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      props.onClick?.(event as unknown as MouseEvent<HTMLButtonElement>)
    }
  }

  return (
    <button
      type='button'
      tabIndex={0}
      aria-pressed={false}
      onKeyDown={handleKeyDown}
      {...props}
      className={`ant-typography-button ${props?.className ?? ''}`}
    />
  )
}

export const Typography = {
  Text,
  Paragraph: AntTypography.Paragraph,
  Title: AntTypography.Title,
  Link: AntTypography.Link,
  Button,
}
